import React from 'react';

import {
    Button,
    Box,
    Typography,
} from "@mui/material";

import { BookSaved, TimerStart } from 'iconsax-react';

import SelectionButton from './SelectionButton';

const AssignmentTaskType = ({ taskType, setTaskType, setActiveStep }) => {

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    return (
        <Box sx={{ textAlign: 'center', p: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Select Assignment Type</Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 3, pl: '100px', pr: '100px' }}>
                Assign reading by minutes, words to read, or specific chapters.
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-evenly', mb: 3, mt: 6 }}>
                <SelectionButton
                    selected={taskType === 'text'}
                    icon={BookSaved}
                    title="Text Selection"
                    description="Assign specific chapters or texts."
                    onSelect={() => setTaskType('text')}
                />
                <SelectionButton
                    selected={taskType === 'metric'}
                    icon={TimerStart}
                    title="Open Reading"
                    description="Set assignments by reading time or word quantity."
                    onSelect={() => setTaskType('metric')}
                />
            </Box>
            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleNext}
                disabled={taskType !== 'text' && taskType !== 'metric'}
            >
              Continue
            </Button>
        </Box>
    );
};

export default AssignmentTaskType;
